<template>
  <div class="cursor-container">
    <div
      class="cursor"
      ref="cursor"
      :data-pointer="$store.state.pointer"
    ></div>
  </div>
</template>

<script>
import engine from '../scripts/engine';
import apollo from '../scripts/apollo';

export default {
  name: 'CursorContainer',

  mounted() {
    engine.add(() => {
      this.$refs.cursor.style.transform = `translate3d(${apollo.ref.mouse.x}px, ${apollo.ref.mouse.y}px, 0px)`;
    }, 'render-mouse');
  },
};
</script>

<style lang="scss" scoped>
.cursor-container {
  @extend %full-fixed;
  pointer-events: none;
  mix-blend-mode: difference;
  z-index: 14;

  @include mq($and: $is-touch-device) {
    visibility: hidden;
  }

  .cursor {
    position: relative;
    width: 50px;
    height: 50px;

    background-position: top left;
    background-size: contain;
    background-repeat: no-repeat;

    &[data-pointer="default"] {
      background-image: url('/static/cursor/arrow.png');
    }

    &[data-pointer="pointer"] {
      left: -20px;
      background-image: url('/static/cursor/pointer.png');
    }

    &[data-pointer="loading"] {
      left: -20px;
      background-image: url('/static/cursor/loading.png');
    }

    &[data-pointer="buy"] {
      left: -20px;
      background-image: url('/static/cursor/dollah.png');
    }
  }
}
</style>
